import { FormErrorMessage, Text } from "@chakra-ui/react";
import type { SourcingEventV2Dto, SourcingEventV2PatchDto } from "../../../../../autogen/bff-api";
import { useEditor, useFieldErrorTranslation, type FieldError } from "../../../../../common/editing/save-coordinator";

interface Options {
  childrenShowTheirOwnErrors?: boolean;
}

export const useFieldSaveError = (
  eventId: string,
  path: string,
  { childrenShowTheirOwnErrors = false }: Options = {},
): FieldError | undefined => {
  const { fieldError, fieldErrorWithin } = useEditor<SourcingEventV2Dto, SourcingEventV2PatchDto>(eventId);
  const rejected = fieldErrorWithin(path);
  const own = fieldError(path);
  if (rejected) return childrenShowTheirOwnErrors && rejected !== own ? undefined : rejected;
  return own;
};

export const FieldSaveError = ({ eventId, path, ...options }: { eventId: string; path: string } & Options) => {
  const formatFieldError = useFieldErrorTranslation();
  const error = useFieldSaveError(eventId, path, options);
  if (!error) return null;
  return (
    <Text role="alert" fontSize="sm" color="smError" mt="1">
      {formatFieldError(error)}
    </Text>
  );
};

export const FieldSaveErrorMessage = ({ error }: { error: FieldError | undefined }) => {
  const formatFieldError = useFieldErrorTranslation();
  return error ? <FormErrorMessage>{formatFieldError(error)}</FormErrorMessage> : null;
};
